module.exports = __webpack_public_path__ + "static/img/lp3.9db2fbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/brightscreentime/brightscreentime/lp3.png
// module id = aENQ
// module chunks = 0